import React, { Component , Fragment,useEffect,useState,useContext,useRef } from "react";
import profileService from "../services/profile.service";
import Pagetitle from "../components/Pagetitle";
import { AuthContext } from '../context/authContext'
import { useNavigate } from 'react-router-dom';
import alertService from '../services/sweetAlert';
import Load from "../components/Load";
import { Avatar } from "@mui/material";
import { Link } from "react-router-dom";


function Grps() {

    const [groupList, setGroupList] = useState([]);
    const [dummy, setDummy] = useState([]);
    const cdn = "https://files.geetsuhane.com/";
    const navigate = useNavigate()
    const { currentUser } = useContext(AuthContext);
  const inputRefName = useRef(null);

    if(currentUser==null)
    {
      localStorage.setItem("redirect", "/planets")
      navigate('/login')
    } 

    var CreatePlanet = async () => {
      if(inputRefName.current.value==="") {
       //return alert("name field is empty!");
       alertService.error(
           'Virtual Planet',
           'VP Name can not be empty!'
         )   
         return;
      }
      const confirmed = await alertService.confirm(
          'Virtual Planet',
        'Are you sure you want to create a virual planet and leave the existing group?'
      )
      if (confirmed) {
        var res = await profileService.getResult({
            qry: `CALL sp_createVP('${currentUser?.id}', '${inputRefName.current.value}')`
        });
        if(res[0][0]?.res=='new') {
                console.log(res[0][0]);
                
                alertService.error(
                  'You need to wait',
                  'You need to be atleast 9 months old on GS!'
                )   
              return;
              } else if(res[0][0]?.res=='exists') {
                alertService.error(
                  'Duplicate Name',
                  'This VP Name already exists, please try again!'
                )   
              return;
            } else if(res?.[0][0]?.res==='owner') {
             
              alertService.error(
                  'Error!',
                  `You are already owner of the virual planet`
                )
                return;
               
            } else if(res[0][0]?.res=='success') {

              inputRefName.current.value='';
           
            alertService.info(
                'Congratulations!', 
                'You have sucessfully created a new virtual planet '+ inputRefName.current.value
              )
             await getGroups();
        }
      }
    }

     

    const getGroups = async () => {        
      var grpList = await profileService.getResult({
        qry: `CALL sp_groupDetails('${currentUser?.id}')`
      });
      setGroupList(grpList[0]);
      setDummy(grpList[0]);

      //console.log(groupList);

    }
    const joinGroup = async (actiontype,groupid, groupname) => {
       // console.log(actiontype)
        const confirmed = await alertService.confirm(
            actiontype=='join?Join:Leave'+ ' Planet',
            'Are you sure you want to '+ actiontype+ ' ' + groupname + '?'
          )
          if (confirmed) {
            console.log(res);
            var res = await profileService.getResult({
                qry: `CALL sp_addToGroup('${actiontype}','','${currentUser?.SID}', ${groupid})`
            });
            console.log(res)
            if(res?.[0][0]?.res==='exists') {
                  
                    const group = res[0][0].res;
                    alertService.error(
                        'Error!',
                        `You are already a member of planet`
                      )
            } else if(res?.[0][0]?.res==='soon') {
                      //console.log(res[0]);
                     
                      alertService.error(
                          'Error!',
                          `you need to wait atlast 96 hours`
                        )
                        return;
            } else if(res?.[0][0]?.res==='duplicate') {
              alertService.error(
                  'Error!',
                  `you have already submitted request to join this planet`
                )
                return;
             } else if(res?.[0][0]?.res==='owner') {
              //console.log(res[0]);
             
              alertService.error(
                  'Error!',
                  `You are owner of this virual planet so can not leave`
                )
                return;
            } else {
                const msgtype = (actiontype==='leave'?'Planet Left':'Congratulations');
                const msg = (actiontype==='leave'?'left':'joined');

                if(actiontype==='join') {
                  alertService.info(
                    msgtype, 
                    'You have sucessfully submitted request to join  '+ groupname+ ', please wait for approval!'
                  )
                } else {
                  alertService.info(
                    msgtype, 
                    'You have sucessfully '+msg+' '+ groupname
                  )
                }
               
            }
          }
          getGroups();
    }
    const searchChange = p => {          
        if(p.length>0) {
            setGroupList(
                groupList.filter(grp => {
                  return grp.name.toLowerCase().includes(p.toLowerCase())
                })
              )
        } else {
            //console.log(dummyList);
            setGroupList(dummy);
        }
       
      }
    useEffect(() => {
        async function fetchGroups() {
          await getGroups();
        }
        fetchGroups();
      }, []);
        return (
            <Fragment>     
                <div className="main-content right-chat-active planets-page">
                    <div className="middle-sidebar-bottom">
                        <div className="middle-sidebar-left pe-0">
                            <div className="row">
                              
                                <div className="col-xl-12">
                                {/* <div className="row">
                                            <div className="col-lg-6 mb-3">
                                                <div className="form-group">
                                                    <label className="mont-font fw-600 font-xsss mb-2 strong pt-2">Create Your Own Virtual Planet</label>
                                                    <input type="text"  className="form-control" placeholder="VP Name" ref={inputRefName} />                                                   
                                                </div>        
                                                <div className="row justify-content-center p-1">
                                                <a  onClick={()=>CreatePlanet()} className="bg-current text-center text-white font-xssss fw-600 p-2 w175 rounded-3 d-inline-block">Create</a>
                                            </div>
                                            <div className="font-xsssss">Note: You need to bring atleast 20 new or existing members and minimum 50000 points should be within 7 days, otherwise 
                                              your new VP will be dissolved. you will not be allowed to create VP again for next 3 months!
                                              </div>
                                              <div className="font-xsssss text-red strong">Top 1 VP owner can become a planet owner of real GS planet and Co-Captian too, if your virtual planet is #1 in month end.</div>
                                            </div>

                                          
                                        </div> */}
                                    
                                    <Pagetitle header="Planets" onChange={searchChange}/>
                                    {!groupList[0]? (
                                                <Load></Load>
                                            ):''
                                        }
                                    
                                    <div>
                                        {groupList.map((value , index) => (

                                        <div key={index} className="card d-flex flex-row align-items-center border-0 shadow-xss rounded-3 mb-2 p-3" style={{ background: '#fff' }}>
                                          <span className="fw-700 text-grey-500 me-3" style={{ minWidth: '25px' }}>#{index + 1}</span>
                                          <Avatar
                                            sx={{ width: 50, height: 50, border: '2px solid #eee' }}
                                            src={cdn+value?.pic}
                                          />
                                          <div className="flex-grow-1 ms-3">
                                            <h4 className="fw-700 font-xss mb-0">{value.name}</h4>
                                            <div className="d-flex align-items-center gap-2 mt-1">
                                              <span className="font-xssss text-grey-500">
                                                <img src="https://files.geetsuhane.com/home/points.png" alt="DW" className="w15" /> {value?.points?.toLocaleString()}
                                              </span>
                                              {value?.gname === value?.name && (
                                                <span className="badge bg-success font-xsssss">Your Planet</span>
                                              )}
                                            </div>
                                          </div>
                                          <div className="d-flex gap-2">
                                            <a onClick={()=>joinGroup(value?.gname===value?.name?'leave':'join',value.id,value.name,value.pic)} style={{ cursor: 'pointer' }}>
                                              <i className={`${value?.name===value.gname?'bg-red-gradiant feather-user-x':'bg-primary feather-user-plus'} font-xs text-white text-center counter btn-round-sm`}></i>
                                            </a>
                                            <Link to={`/search?groupDetail=${value.name}`}>
                                              <i className='font-xs text-white text-center feather-users counter btn-round-sm bg-dark'></i>
                                            </Link>
                                          </div>
                                        </div>

                                        ))}

                                    </div>
                                </div>               
                            </div>
                        </div>
                        
                    </div>
                </div>
              
            </Fragment>
        );
    }


export default Grps;   